import translate from 'translate'

// Configure translate package
translate.engine = 'google'
translate.key = undefined // Use free version

/**
 * Dynamically translates text from English to the target language
 * @param text - The English text to translate
 * @param targetLanguage - The target language code (e.g., 'fr', 'es', 'de')
 * @returns The translated text
 */
export const translateText = async (
  text: string,
  targetLanguage: string
): Promise<string> => {
  try {
    // If target language is English, return the original text
    if (targetLanguage === 'en' || !targetLanguage) {
      return text
    }

    // Translate the text
    const translated = await translate(text, targetLanguage)
    return translated
  } catch (error) {
    console.error('Translation error:', error)
    // If translation fails, return the original English text
    return text
  }
}

/**
 * Batch translate multiple error messages
 * @param messages - Array of English messages to translate
 * @param targetLanguage - The target language code
 * @returns Array of translated messages
 */
export const translateBatch = async (
  messages: string[],
  targetLanguage: string
): Promise<string[]> => {
  try {
    if (targetLanguage === 'en' || !targetLanguage) {
      return messages
    }

    const translations = await Promise.all(
      messages.map((msg) => translate(msg, targetLanguage))
    )
    return translations
  } catch (error) {
    console.error('Batch translation error:', error)
    return messages
  }
}

